import { useGraphqlQuery } from "@mzara/component"
import { TAppointment } from "@mzara/graphql"
import { AppointmentQuery } from "queries/AppointmentQuery"

export const useAppointmentQuery = (id?:number,suspense?:boolean, enabled?: boolean)=>{
    return useGraphqlQuery<AppointmentQuery,TAppointment>(new AppointmentQuery({ id }), { enabled: enabled !== false && id !== undefined, suspense })
}